import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'
import { useEffect, useState } from 'react'
import AppLayout from '@components/layout/AppLayout'

import LoginPage      from '@pages/Auth/LoginPage'
import DashboardPage  from '@pages/Dashboard/DashboardPage'
import SitesPage      from '@pages/Sites/SitesPage'
import AlertsPage     from '@pages/Alerts/AlertsPage'
import ActionPlansPage from '@pages/ActionPlans/ActionPlansPage'
import ReportsPage    from '@pages/Reports/ReportsPage'

function PrivateRoute({ children }) {
  const token = useAuthStore((s) => s.token)
  return token ? children : <Navigate to="/login" replace />
}

export default function App() {
  // Wait for Zustand persist to rehydrate from localStorage before rendering routes.
  // Without this, token is null on first render → instant redirect to /login.
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => {
    // useAuthStore.persist.hasHydrated() is synchronous after first render
    const unsub = useAuthStore.persist.onFinishHydration(() => setHydrated(true))
    if (useAuthStore.persist.hasHydrated()) setHydrated(true)
    return unsub
  }, [])

  if (!hydrated) return null // or a <Spinner/> if you prefer

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/app" element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }>
          <Route index element={<Navigate to="/app/dashboard" replace />} />
          <Route path="dashboard"    element={<DashboardPage />} />
          <Route path="sites"        element={<SitesPage />} />
          <Route path="alerts"       element={<AlertsPage />} />
          <Route path="action-plans" element={<ActionPlansPage />} />
          <Route path="reports"      element={<ReportsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
